import styled from '@emotion/styled'
import React, { ReactElement, useState } from 'react'

import { useMobile } from '@/hooks'

import { Dropdown } from '../Dropdown'
import { Tabs } from '../Tabs'

type Props = {
  children: ReactElement[]
}

interface TabChildProps {
  hidden?: boolean
  title?: string
}

export const TabNavigation = ({ children }: Props) => {
  const [dropdownExpanded, setDropdownExpanded] = useState(false)
  const [selectedTab, setSelectedTab] = useState(0)

  const validTabs = children.filter((el) => !(el as ReactElement<TabChildProps>).props.hidden)
  const activeTab = validTabs[selectedTab]

  const { isTablet } = useMobile()

  const handleCancel = () => {
    setDropdownExpanded(false)
  }

  return (
    <>
      {isTablet ? (
        <>
          <div className="flex items-center py-4">
            <Dropdown
              className="w-auto"
              expanded={dropdownExpanded}
              headerTitle={`${(activeTab as ReactElement<TabChildProps>).props.title || ''}`}
              onHideDropdown={handleCancel}
              renderHeader={() => <div></div>}
              selected={true}
              setExpanded={setDropdownExpanded}
            >
              <MobileTabOptionsStyled>
                <ul>
                  {validTabs.map((item, index) => (
                    <li
                      className={`${index === selectedTab ? 'selected' : ''} capitalize`}
                      key={index}
                      onClick={() => {
                        setSelectedTab(index)
                        setDropdownExpanded(false)
                      }}
                      role={'presentation'}
                    >
                      {(item as ReactElement<TabChildProps>).props.title}
                    </li>
                  ))}
                </ul>
              </MobileTabOptionsStyled>
            </Dropdown>
          </div>
          {validTabs.map((_i, index) => (
            <div
              className={
                selectedTab == index
                  ? 'active-tab relative z-10 h-full w-full opacity-100'
                  : 'z-0 hidden h-0 w-0 opacity-0'
              }
              key={index}
            >
              {validTabs[index]}
            </div>
          ))}
        </>
      ) : (
        <DesktopStyledTabs>
          <Tabs>{children}</Tabs>
        </DesktopStyledTabs>
      )}
    </>
  )
}

export const MobileTabOptionsStyled = styled.div`
  @media (min-width: 768px) {
    width: 13rem;
  }

  ul {
    width: 100%;
    padding-top: 0.5rem;
    padding-bottom: 0.25rem;
  }
  li {
    &.selected {
      background-color: #e7e6e4;

      &:hover {
        background-color: #e7e6e4;
      }
    }
    margin-bottom: 0.25rem;
    width: 100%;
    padding-left: 1.5rem;
    padding-right: 1.5rem;
    cursor: pointer;
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
    line-height: 1;
    &:hover {
      background-color: #f3f3f2;
    }
  }
`

const DesktopStyledTabs = styled.div`
  .title-container {
    border-color: #e7e6e4;
    position: relative;
    margin-bottom: 0.5rem;
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
    border-bottom-width: 1px;
    border-bottom-style: solid;
  }

  .tab-title {
    position: relative;
    margin-right: 2rem;

    button {
      white-space: nowrap;
      font-weight: 500;
      line-height: 140%;
      background-color: transparent;
      text-transform: capitalize;
      cursor: pointer;
    }

    &.active {
      button {
        color: #08786c;
        font-weight: 700;
      }

      &::after {
        position: absolute;
        display: block;
        background-color: #08786c;
        content: '';
        left: 0;
        right: 0;
        height: 2px;
        bottom: -0.6rem;
      }
    }
  }
`
